<template>
  <el-dialog
    title="提示"
    :visible.sync="showDialog"
    width="716px"
    :close-on-click-modal="false"
  >
    <div class="forLabel">
      <el-select v-model="curField" placeholder="请选择" style="width: 160px">
        <el-option label="今日头条" value="jrtt"></el-option>
        <el-option label="广点通" disabled value="gdt"></el-option>
      </el-select>
    </div>
    <el-transfer
      filterable
      :props="{ key: 'advertiserId', label: 'advertiserName' }"
      v-model="transferData.value"
      :data="transferData.list"
      class="dialog-wrap"
    ></el-transfer>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showDialog = false">取 消</el-button>
      <el-button type="primary" @click="handlerTransfer">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import produceServer from "@/api/product.js";
export default {
  props: {},
  data() {
    return {
      showDialog: false,
      transferData: {
        list: [],
        value: [],
      },
      curField: "jrtt",
      curProId: null,
    };
  },
  methods: {
    showModal(data) {
      this.getTransferData(data);
      this.curProId = data.id;
      this.showDialog = true;
    },
    getTransferData(data) {
      produceServer
        .getProductAdvertisers({
          productId: data.id,
        })
        .then((res) => {
          if (res.code === "0000") {
            this.transferData.list = res.advertiserList;
            this.transferData.value = res.productPermissionList.map(
              (item) => item.advertiserId
            );
          }
        });
    },
    handlerTransfer() {
      produceServer
        .grantProductPermission({
          productId: this.curProId,
          advertiserIds: this.transferData.value.join(),
        })
        .then((res) => {
          if (res.code === "0000") {
            this.$message({
              showClose: true,
              message: "授权成功",
              type: "success",
            });
            this.showDialog = false;
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-wrap {
  // /deep/ .el-transfer-panel {
  //   width: 245px;
  // }
}
.forLabel {
  margin-bottom: 10px;
}
</style>